import { fExecuteAPI } from "../../Server/Apis";

import { vRdxUserInfo } from "../../Redux/roStore";
const GetLocation = async (setLocation) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vLocobj = {
    AnyData: "",
    Code: "",
    Name: "",
    Parent: "C",
    Distri: "N",
    UserCd: vRdxUserInfoObj.UserID,
  };
  const vLocation = await fExecuteAPI("LOCATION_SEARCH_GETROW", vLocobj);
  if (vLocation?.ResultSet?.length > 0) {
    setLocation(vLocation?.ResultSet);
    return vLocation.ResultSet;
  } else {
    setLocation([]);
    return [];
  }
};
export { GetLocation };
